import React, { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Divider, useMediaQuery } from '@mui/material';
import { LogoutOutlined, AccountCircleOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useGetLoggedInUserData } from '../../../../queries/user-query';
import { LoggedInUser, RoutesEnum, ScreenSize } from '../../../../@types';
import { SAMPLE_LOGIN_USER } from '../../../../constants/user.constant';
import { DrawerFooterProps } from './DrawerFooter.props';

export const DrawerFooter: React.FC<DrawerFooterProps> = ({ toggleDrawer }) => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const [userData, setUserData] = useState<LoggedInUser>(SAMPLE_LOGIN_USER);
  const isMobileView = useMediaQuery(ScreenSize.MOBILE);

  const getLoggedInUserData = useGetLoggedInUserData();

  useEffect(() => {
    getLoggedInUserData.data && setUserData({
      ...userData,
      userName: getLoggedInUserData.data.userName,
      profilePic: getLoggedInUserData.data.profilePic,
    });
  }, [getLoggedInUserData.data]);

  const onLogOut = useCallback(() => {
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);

  return (
    <Box sx={{ width: '100%', mt: 'auto', mb: '10px', color: 'common.white' }}>
      <Divider sx={{ borderColor: '#334155' }} />
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          alignItems: 'center',
          pt: '16px',
          pb: '8px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px' }}>
          <Box
            onClick={() => {
              navigate(RoutesEnum.ProfileRoute, { replace: true });
              isMobileView && toggleDrawer();
            }}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            role="button"
            tabIndex={0}
            aria-label="Go to profile"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                navigate(RoutesEnum.ProfileRoute, { replace: true });
                isMobileView && toggleDrawer();
              }
            }}
          >
            {userData.profilePic && userData.profilePic !== '' ? (
              <Box
                component="img"
                src={userData.profilePic}
                alt="Profile"
                sx={{
                  height: 32,
                  width: 32,
                  borderRadius: '50%',
                }}
              />
            ) : (
              <AccountCircleOutlined fontSize="medium" />
            )}
          </Box>
          <Box sx={{ pl: '8px', minWidth: '80px' }}>
            {userData.userName}
          </Box>
        </Box>
        <Box
          onClick={onLogOut}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: '#94a3b8',
            '&:hover': { color: '#fff' },
          }}
          role="button"
          tabIndex={0}
          aria-label="Log out"
          onKeyDown={(e) => e.key === 'Enter' && onLogOut()}
        >
          <LogoutOutlined sx={{ fontSize: 18 }} />
        </Box>
      </Box>
    </Box>
  );
};
